<template>
  <div class="header_col">
    <div class="hco_col">
      <div class="header-l"><a href="/" aria-current="page" class="logo-lw w-inline-block w--current"><img
          src="/img/trip/webflow/647f7f5aa8c5d20a54ebdde7_colonnade.png"
          loading="lazy" alt="" class="logo"></a></div>
      <div class="header-r">
        <div class="header-i">
          <div class="tp_col">
            <div class="tpx_t"> Asistenčná služba v prípade vzniku škody</div>
            <div class="rws">
              <div class="ico fc-2 mr"></div>
              <div><a href="mailto:ga@1220.cz" class="contact-link"><strong>ga@1220.cz</strong></a><br></div>
            </div>
            <div class="rws">
              <div class="ico fc-2 mr"></div>
              <div><a href="tel:+421911803500" class="contact-link"><strong>+ 421 911 803 500</strong></a><br></div>
            </div>
          </div>
          <div class="tp_col">
            <div class="tpx_t">Otázky k dojednaniu poistenia</div>
            <div class="rws">
              <div class="ico fc-2 mr"></div>
              <div><a href="mailto:info@travelinsurance.sk" class="contact-link"><strong>info@travelinsurance.sk</strong></a><br></div>
            </div>
            <div class="rws">
              <div class="ico fc-2 mr"></div>
              <div><a href="tel:+421917858738" class="contact-link"><strong>+421 917 858 738</strong></a><br></div>
            </div>
          </div>
        </div>
        <a href="#" class="ham w-inline-block">
          <div class="hm hm1"></div>
          <div class="hm hm2"></div>
          <div class="hm hm3"></div>
        </a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderPart",
  props: {
    product: String
  }

}
</script>

<style scoped>
/*header{*/
/*  position: absolute;*/
/*  padding: 20px;*/
/*  z-index: 20;*/
/*  left: 20PX;*/
/*  right: 20PX;*/
/*  box-sizing: border-box;*/
/*}*/
/*  .header-co {*/
/*    width: 100%;*/
/*    border-bottom: 1px solid #00b14e;*/
/*    justify-content: space-between;*/
/*    align-items: center;*/
/*    margin-left: auto;*/
/*    margin-right: auto;*/
/*    padding: 20px 4px;*/
/*    display: flex;*/
/*    position: relative;*/
/*    color: white;*/
/*  }*/
/*  .logo{*/
/*    width: 140px;*/
/*  }*/

/*  h1 a{*/
/*    text-decoration: none;*/
/*  }*/

/*  a{*/
/*    text-decoration: none;*/
/*    color: white;*/
/*  }*/

.contact-link {
  color: inherit;
  text-decoration: none;
  font: inherit;
}
</style>